// extracted by mini-css-extract-plugin
module.exports = {"defaultCarrouselHeight":"200","defaultCarrouselArrowsize":"50px","defaultCarrouselLegendSize":"10px","defaultCarrouselLegendActive":"14px","defaultCarrouselLegendTouchable":"30px"};